import { Col, ModalProps, Row } from "antd";
import { Button } from "components/ui-component";
import ModalStyle from "components/ui-component/Modal/Modal.style";

export interface CommonModalProps extends Omit<ModalProps, "open"> {
  open: boolean;
  onOk?: () => void;
  onCancel?: () => void;
  okText?: string;
  cancelText?: string;
  footer?: React.ReactNode;
  children?: React.ReactNode;
  isLoading?: boolean;
  isCancelButton?: boolean;
  isOkButton?: boolean;
  htmlType?: "button" | "submit" | "reset";
  cancelButtonType?: "default" | "primary" | "dashed" | "text" | "link";
}

const CommonModal: React.FC<CommonModalProps> = ({
  open,
  title,
  onOk,
  onCancel,
  okText = "OK",
  cancelText = "Cancel",
  width = 520,
  isCancelButton = true,
  isOkButton = true,
  footer,
  destroyOnClose = true,
  centered = true,
  maskClosable = false,
  closable = false,
  isLoading = false,
  cancelButtonType,
  htmlType,
  children,
  className,
  ...rest
}) => {
  return (
    <ModalStyle
      open={open}
      title={title}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      width={width}
      centered={centered}
      maskClosable={maskClosable}
      className={className}
      closable={closable}
      footer={
        <Row>
          <Col xs={24} lg={12} />
          <Col xs={24} lg={12}>
            <div className="footerright">
              {isCancelButton && (
                <Button
                  size="small"
                  onClick={onCancel}
                  disabled={isLoading}
                  type={cancelButtonType}
                  // className="text"
                >
                  {cancelText}
                </Button>
              )}
              {isOkButton && (
                <Button
                  type="primary"
                  size="small"
                  loading={isLoading}
                  onClick={onOk}
                  htmlType={htmlType}
                >
                  {okText}
                </Button>
              )}
            </div>
          </Col>
        </Row>
      }
      {...rest}
    >
      {children}
    </ModalStyle>
  );
};

export default CommonModal;
